﻿export const MAP_RESOURCES_URL = 'map/resources?type=map';
export const GENERAL_RESOURCES_URL = 'map/resources?type=general';
export const STYLE_KEYWORDS = 'style/getkeywords';
export const STYLE_LIST_URL = 'style/getconfigstyles';
export const STYLE_PREVIEW_URL = 'img/style/';